import { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

interface Product {
  id: string;
  name: string;
  price: number;
  originalPrice: number;
  image: string;
  category: string;
  rating: number;
  reviews: number;
  sizes: string[];
  colors: string[];
  inStock: boolean;
}

export const ThemesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [ageRange, setAgeRange] = useState('All');

  const categories = ['All', 'Dresses', 'Abayas', 'Hijabs', 'Sets'];
  const ageRanges = ['All', '2-4 years', '5-7 years', '8-10 years'];

  // Mock data for girls' cultural wear - faces allowed for children under 10
  const girlsProducts: Product[] = [
    {
      id: 'girls-1',
      name: 'Little Princess Embroidered Dress Set',
      price: 35,
      originalPrice: 45,
      image: 'https://public.readdy.ai/ai/img_res/f606ddf207ac429c2568d2b6a45d1cd8.jpg',
      category: 'Dresses',
      rating: 5,
      reviews: 28,
      sizes: ['2-3Y', '4-5Y', '6-7Y'],
      colors: ['Emerald', 'Rose', 'Cream'],
      inStock: true
    },
    {
      id: 'girls-2',
      name: 'Floral Garden Abaya for Girls',
      price: 38,
      originalPrice: 48,
      image: 'https://readdy.ai/api/search-image?query=cute%20young%20girl%20age%206%20wearing%20elegant%20floral%20embroidered%20abaya%20in%20soft%20pink%20color%20with%20matching%20hijab%2C%20cheerful%20expression%2C%20studio%20photography%20with%20natural%20lighting%2C%20Islamic%20children%20modest%20fashion%2C%20traditional%20cultural%20dress&width=400&height=500&seq=girls-abaya-1&orientation=portrait',
      category: 'Abayas',
      rating: 5,
      reviews: 35,
      sizes: ['4-5Y', '6-7Y', '8-9Y'],
      colors: ['Pink', 'Lavender', 'Mint'],
      inStock: true
    },
    {
      id: 'girls-3',
      name: 'Rainbow Butterfly Hijab Set',
      price: 22,
      originalPrice: 28,
      image: 'https://readdy.ai/api/search-image?query=happy%20young%20girl%20age%207%20wearing%20colorful%20butterfly%20print%20hijab%20with%20matching%20dress%2C%20bright%20smile%2C%20studio%20portrait%2C%20Islamic%20children%20modest%20wear%2C%20vibrant%20colors%20on%20cream%20background%2C%20cultural%20fashion%20for%20kids&width=400&height=500&seq=girls-hijab-1&orientation=portrait',
      category: 'Hijabs',
      rating: 5,
      reviews: 42,
      sizes: ['One Size'],
      colors: ['Multi', 'Pink', 'Blue'],
      inStock: true
    },
    {
      id: 'girls-4',
      name: 'Golden Stars Occasion Set',
      price: 42,
      originalPrice: 55,
      image: 'https://readdy.ai/api/search-image?query=beautiful%20young%20girl%20age%208%20wearing%20elegant%20gold%20embroidered%20special%20occasion%20abaya%20dress%20with%20hijab%2C%20joyful%20expression%2C%20studio%20photography%2C%20Islamic%20children%20formal%20wear%2C%20cream%20and%20gold%20colors%2C%20traditional%20modest%20fashion&width=400&height=500&seq=girls-occasion-1&orientation=portrait',
      category: 'Sets',
      rating: 5,
      reviews: 31,
      sizes: ['6-7Y', '8-9Y', '10-11Y'],
      colors: ['Gold', 'Cream', 'White'],
      inStock: true
    },
    {
      id: 'girls-5',
      name: 'Soft Cotton Daily Wear Abaya',
      price: 28,
      originalPrice: 35,
      image: 'https://readdy.ai/api/search-image?query=sweet%20young%20girl%20age%205%20wearing%20comfortable%20soft%20cotton%20abaya%20in%20pastel%20color%20with%20simple%20hijab%2C%20natural%20smile%2C%20studio%20portrait%20with%20soft%20lighting%2C%20Islamic%20children%20everyday%20modest%20wear%2C%20simple%20elegant%20design&width=400&height=500&seq=girls-daily-1&orientation=portrait',
      category: 'Abayas',
      rating: 5,
      reviews: 48,
      sizes: ['2-3Y', '4-5Y', '6-7Y', '8-9Y'],
      colors: ['Beige', 'Gray', 'Navy'],
      inStock: true
    },
    {
      id: 'girls-6',
      name: 'Lace Trim Party Dress',
      price: 45,
      originalPrice: 58,
      image: 'https://readdy.ai/api/search-image?query=cheerful%20young%20girl%20age%209%20wearing%20beautiful%20lace%20trim%20party%20dress%20with%20elegant%20hijab%20in%20emerald%20green%2C%20happy%20expression%2C%20studio%20photography%2C%20Islamic%20children%20formal%20occasion%20wear%2C%20luxurious%20modest%20fashion%20for%20kids&width=400&height=500&seq=girls-party-1&orientation=portrait',
      category: 'Dresses',
      rating: 5,
      reviews: 26,
      sizes: ['6-7Y', '8-9Y', '10-11Y'],
      colors: ['Emerald', 'Burgundy', 'Navy'],
      inStock: true
    },
    {
      id: 'girls-7',
      name: 'Pastel Dreams Hijab Collection',
      price: 18,
      originalPrice: 24,
      image: 'https://readdy.ai/api/search-image?query=adorable%20young%20girl%20age%206%20wearing%20soft%20pastel%20colored%20hijab%20with%20matching%20outfit%2C%20sweet%20smile%2C%20studio%20portrait%2C%20Islamic%20children%20modest%20wear%2C%20gentle%20colors%20on%20cream%20background%2C%20comfortable%20everyday%20hijab%20for%20kids&width=400&height=500&seq=girls-hijab-2&orientation=portrait',
      category: 'Hijabs',
      rating: 5,
      reviews: 52,
      sizes: ['One Size'],
      colors: ['Peach', 'Mint', 'Lilac'],
      inStock: true
    },
    {
      id: 'girls-8',
      name: 'Eid Special Embroidered Set',
      price: 52,
      originalPrice: 68,
      image: 'https://readdy.ai/api/search-image?query=beautiful%20young%20girl%20age%207%20wearing%20luxurious%20Eid%20special%20embroidered%20dress%20and%20hijab%20set%20in%20rich%20emerald%20and%20gold%2C%20joyful%20celebration%20expression%2C%20studio%20photography%2C%20Islamic%20children%20festive%20wear%2C%20traditional%20cultural%20celebration%20outfit&width=400&height=500&seq=girls-eid-1&orientation=portrait',
      category: 'Sets',
      rating: 5,
      reviews: 38,
      sizes: ['4-5Y', '6-7Y', '8-9Y', '10-11Y'],
      colors: ['Emerald', 'Burgundy', 'Royal Blue'],
      inStock: true
    }
  ];

  const filteredProducts = girlsProducts.filter(product => {
    const categoryMatch = selectedCategory === 'All' || product.category === selectedCategory;
    
    let ageMatch = true;
    if (ageRange === '2-4 years') {
      ageMatch = product.sizes.some(size => ['2-3Y', '4-5Y'].includes(size));
    } else if (ageRange === '5-7 years') {
      ageMatch = product.sizes.some(size => ['4-5Y', '6-7Y'].includes(size));
    } else if (ageRange === '8-10 years') {
      ageMatch = product.sizes.some(size => ['8-9Y', '10-11Y'].includes(size));
    }
    
    return categoryMatch && ageMatch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream-100 to-white">
      <Header />
      
      {/* Hero Section - Children's Fashion (Faces Allowed) */}
      <section className="relative py-24 bg-gradient-to-br from-emerald-700 via-emerald-600 to-emerald-500 overflow-hidden">
        {/* Background Image - Happy Children in Modest Wear */}
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=group%20of%20happy%20young%20children%20ages%205-8%20wearing%20colorful%20beautiful%20Islamic%20modest%20clothing%20abayas%20and%20hijabs%2C%20joyful%20smiling%20faces%2C%20playing%20together%2C%20studio%20photography%20with%20cream%20background%2C%20cultural%20children%20fashion%2C%20traditional%20modest%20wear%20celebration&width=1920&height=800&seq=girls-hero-group-1&orientation=landscape"
            alt="Girls' Cultural Wear"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/70 via-emerald-800/60 to-emerald-900/70"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center text-white max-w-4xl mx-auto">
            {/* Decorative Top Divider */}
            <div className="flex items-center justify-center mb-6">
              <div className="h-px w-16 bg-gold-400"></div>
              <div className="w-2 h-2 bg-gold-400 rounded-full mx-3"></div>
              <div className="h-px w-16 bg-gold-400"></div>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-cream-100" style={{ fontFamily: '"Playfair Display", serif' }}>
              Girls' Cultural Wear
            </h1>
            <p className="text-xl md:text-2xl text-cream-100 leading-relaxed max-w-2xl mx-auto mb-6">
              Beautiful modest fashion for little princesses. Comfortable, elegant, and perfect for every occasion—from daily wear to special celebrations.
            </p>
            
            {/* Decorative Bottom Divider */}
            <div className="flex items-center justify-center">
              <div className="h-px w-16 bg-gold-400"></div>
              <div className="w-2 h-2 bg-gold-400 rounded-full mx-3"></div>
              <div className="h-px w-16 bg-gold-400"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Filters Section */}
      <section className="py-8 bg-white border-b border-cream-300 sticky top-20 z-40 shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-6 items-center justify-between">
            {/* Category Filter */}
            <div className="flex flex-wrap gap-2 items-center">
              <span className="text-sm font-semibold text-emerald-800 mr-2">Category:</span>
              {categories.map(category => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer border-2 ${
                    selectedCategory === category
                      ? 'bg-emerald-600 text-white border-emerald-600 shadow-md'
                      : 'bg-white text-emerald-700 border-emerald-200 hover:border-emerald-400 hover:bg-emerald-50'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Age Filter */}
            <div className="flex flex-wrap gap-2 items-center">
              <span className="text-sm font-semibold text-emerald-800 mr-2">Age:</span>
              {ageRanges.map(range => (
                <button
                  key={range}
                  onClick={() => setAgeRange(range)}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer border-2 ${
                    ageRange === range
                      ? 'bg-gold-500 text-white border-gold-500 shadow-md'
                      : 'bg-white text-gold-600 border-gold-200 hover:border-gold-400 hover:bg-gold-50'
                  }`}
                >
                  {range}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="mb-8 flex items-center justify-between">
            <p className="text-emerald-800 font-medium">
              Showing {filteredProducts.length} {filteredProducts.length === 1 ? 'item' : 'items'}
            </p>
            <div className="flex items-center space-x-2 text-sm text-emerald-700">
              <div className="w-3 h-3 bg-gold-500 rounded-full"></div>
              <span className="font-medium">Ready to Ship</span>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-product-shop>
            {filteredProducts.map((product) => (
              <Link key={product.id} to={`/product/${product.id}`}>
                <div className="group cursor-pointer">
                  <div className="bg-cream-50 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden border-2 border-transparent hover:border-gold-400">
                    <div className="relative">
                      <div className="w-full h-96 bg-white">
                        <img 
                          src={product.image}
                          alt={product.name}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      
                      {/* Ready to Ship Badge */}
                      {product.inStock && (
                        <div className="absolute top-4 left-4 bg-gold-500 text-white px-3 py-1.5 rounded-full text-xs font-bold shadow-lg flex items-center space-x-1">
                          <div className="w-2 h-2 bg-white rounded-full"></div>
                          <span>Ready to Ship</span>
                        </div>
                      )}
                      
                      {/* Wishlist Button */}
                      <div className="absolute top-4 right-4">
                        <button className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-colors cursor-pointer">
                          <i className="ri-heart-line text-emerald-700 text-lg"></i>
                        </button>
                      </div>
                    </div>
                    
                    <div className="p-5">
                      <h3 className="text-base font-bold text-emerald-900 mb-3 line-clamp-2 leading-snug" style={{ fontFamily: '"Lora", serif' }}>
                        {product.name}
                      </h3>
                      
                      {/* Size Info */}
                      {product.sizes && product.sizes.length > 0 && (
                        <div className="flex items-center space-x-2 mb-3">
                          <span className="text-xs text-emerald-700 font-medium">Sizes:</span>
                          <span className="text-xs text-gray-600">{product.sizes.join(', ')}</span>
                        </div>
                      )}
                      
                      {/* Rating */}
                      <div className="flex items-center mb-3">
                        <div className="flex text-gold-500 text-sm">
                          {[...Array(5)].map((_, i) => (
                            <i key={i} className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'}`}></i>
                          ))}
                        </div>
                        <span className="text-xs text-gray-500 ml-2">({product.reviews})</span>
                      </div>
                      
                      {/* Price and CTA */}
                      <div className="flex items-center justify-between pt-3 border-t border-cream-200">
                        <div className="flex items-baseline space-x-2">
                          <span className="text-2xl font-bold text-emerald-800">${product.price}</span>
                          {product.originalPrice > product.price && (
                            <span className="text-sm text-gray-400 line-through">${product.originalPrice}</span>
                          )}
                        </div>
                        <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer shadow-md">
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Our Girls' Collection */}
      <section className="py-16 bg-gradient-to-r from-cream-100 to-cream-200">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="flex items-center justify-center mb-6">
              <div className="h-px w-12 bg-gold-500"></div>
              <div className="w-2 h-2 bg-gold-500 rounded-full mx-3"></div>
              <div className="h-px w-12 bg-gold-500"></div>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Perfect for Little Princesses
            </h2>
            
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Our girls' collection combines comfort, quality, and cultural beauty. Each piece is designed with care to ensure your little ones feel confident and comfortable while celebrating their heritage.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-3-line text-3xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Comfortable Fabrics</h3>
                <p className="text-sm text-gray-600">Soft, breathable materials perfect for active kids</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-gold-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-sparkles-line text-3xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Beautiful Designs</h3>
                <p className="text-sm text-gray-600">Elegant styles that kids love to wear</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Quality Guaranteed</h3>
                <p className="text-sm text-gray-600">Durable construction for everyday wear</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-emerald-700 to-emerald-600">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Need Help Finding the Perfect Size?
          </h2>
          <p className="text-lg text-cream-100 mb-8 max-w-2xl mx-auto">
            Our team is here to help you choose the right size and style for your little princess. Contact us for personalized assistance!
          </p>
          <Link
            to="/contact"
            className="inline-block bg-gold-500 hover:bg-gold-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer shadow-lg"
          >
            Contact Us Today
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};